import { SecurityEvent, AffiliateProduct } from './types.js';

export const DECADES = [
  "Ancient Time",
  "1940-1969",
  "1970-1979",
  "1980-1989",
  "1990-1999",
  "2000-2009",
  "2010-2019",
  "2020-2025"
];

export const AFFILIATE_PRODUCTS: AffiliateProduct[] = [
  {
    id: 'nordvpn',
    name: 'NordVPN',
    category: 'VPN',
    description: 'Leading VPN service with military-grade encryption, 5,500+ servers in 60+ countries, and strict no-logs policy. Protects against data interception and provides secure access to geo-restricted content.',
    affiliateUrl: 'https://go.nordvpn.net/aff_c?offer_id=15&aff_id=138562&url_id=902',
    rating: 4.8,
    isTopPick: true,
    priceTag: 'Starting at $3.99/month',
    targetAttackTypes: ['Man-in-the-Middle Attack', 'Data Interception', 'Public WiFi Vulnerabilities', 'Geo-restriction Bypass']
  },
  {
    id: 'nordpass',
    name: 'NordPass',
    category: 'Password Manager',
    description: 'Secure password manager with encrypted cloud sync, password generator, and dark web monitoring. Helps prevent credential theft and promotes strong password hygiene.',
    affiliateUrl: 'https://go.nordpass.io/aff_c?offer_id=488&aff_id=138562&url_id=9356',
    rating: 4.7,
    isTopPick: true,
    priceTag: 'Starting at $1.49/month',
    targetAttackTypes: ['Credential Theft', 'Password Attacks', 'Phishing', 'Social Engineering']
  }
];

export const MOCK_EVENTS: SecurityEvent[] = [
  {
    id: 'solarwinds-2020',
    eventYear: 2020,
    decade: "2020-2025",
    title: "SolarWinds Orion Supply Chain Breach",
    attackType: "Supply Chain Compromise",
    targetNode: "Software Build Server",
    targetedAsset: "Global Enterprise Trust & Data Integrity",
    attacker: {
      name: "APT29 (Cozy Bear)",
      organization: "SVR Intelligence Service",
      unit: "h",
      node: "h",
      city: "Moscow",
      country: "Russia"
    },
    victim: {
      name: "SolarWinds Worldwide",
      organization: "gf",
      unit: "",
      node: "IT Infrastructure Software",
      city: "Austin",
      country: "USA"
    },
    attackerArsenal: [
      { 
        name: "SUNBURST", 
        builder: "State-SVR", 
        mechanism: "Malicious DLL injected into legitimate software updates." 
      },
      { 
        name: "SUNSPOT", 
        builder: "State-SVR", 
        mechanism: "Automated monitor to inject source code during the build process." 
      }
    ],
    victimSystemsAffected: [
      { 
        name: "Orion Platform", 
        builder: "SolarWinds", 
        mechanism: "IT monitoring and network management system." 
      }
    ],
    attackSequence: [
      "Gained initial access to SolarWinds internal network via credential theft.",
      "Moved laterally to the software build environment.",
      "Deployed SUNSPOT to watch for the Orion build process.",
      "Injected SUNBURST code into the legitimate source repository.",
      "Distributed signed, malicious updates to 18,000 customers globally."
    ],
    trafficFlowAnalysis: "Stealthy C2 communication over HTTPS disguised as legitimate Orion Improvement Program telemetry.",
    barrierBypass: "Abused the inherent trust of digitally signed software updates.",
    executionOnTarget: "Mass exfiltration of sensitive US federal agency emails and intelligence.",
    strategicImpact: "Total erosion of trust in the global software supply chain.",
    operationalLosses: "Billions in remediation costs; irreparable damage to US federal cybersecurity reputation.",
    detectionMoment: 'After Exploit',
    preAttackPosture: {
      defenseStack: [
        { 
          name: "Code Signing", 
          builder: "DigiCert", 
          mechanism: "Cryptographic verification of binary integrity." 
        }
      ],
      criticalLimitations: "Assumed the build environment producing the binaries was untainted."
    },
    postAttackPosture: {
      recoveryStack: [
        { 
          name: "SBOM (Software Bill of Materials)", 
          builder: "CISA", 
          mechanism: "Granular visibility into software component provenance." 
        }
      ],
      containmentLimitations: "Threat was undetected for over 9 months, allowing massive data egress."
    },
    strategicEvolution: {
      incidentResponse: "Global recall of Orion versions and forced MFA for all developer accounts.",
      modernizedDefenseStrategy: "Shift toward 'Zero Trust' and multi-environment build verification."
    },
    persuasiveStory: "In 2020, the world learned that you don't need to break down the front door if you can poison the factory that makes the keys. The SolarWinds breach was a masterpiece of patient, state-sponsored espionage. By infiltrating the software build pipeline, the attackers turned a routine update into a trojan horse that was welcomed into 18,000 corporate and government networks. It was the ultimate 'trusted insider' attack, except the insider was the software itself. For months, the most powerful agencies in the world were being monitored by a ghost in the machine that had been hand-delivered by their own IT team.",
    references: ["CISA Alert AA20-352A", "FireEye Threat Research Report"],
    adSlot: "3721511676",
    adClient: "ca-pub-9325373695328890",
    affiliateInfo: {
      productName: "Yubico YubiKey 5C",
      category: "Hardware MFA",
      description: "Phishing was the root cause of the initial SolarWinds access. Hardware-backed MFA is the only way to stop credential theft from scaling into a global catastrophe.",
      link: "https://www.yubico.com/",
      priceTag: "$55.00",
      rating: 5,
      ctaText: "Protect Your Hardware"
    }
  }
];